<template>
    <v-text-field @keyup="checkDate($event, field, 'keyup')"
                  @change="checkDate($event, field, 'change')"
                  type="date"
                  v-model="dataObject[field.id]"
                  :label="field.app"
                  :rules="rules"
                  :hide-details="hideDetails"
                  :errorMessages="getErrorMsg(field)">
    </v-text-field>
</template>

<script>
    import TimeStamp from "../../services/timeStamp";

    export default {
        name: "input-date-optional",
        props: {
            dataObject: {default: null},
            field: {default: null},
            rules: {default: undefined},
            hideDetails: {default: false},
        },
        data: () => ({
            isValid: true,
        }),
        methods: {
            checkDate(event, field, type){
                const value = type === 'change' ? event : event.target.value;
                if ( type !== 'change' && event.srcElement.validationMessage ) {
                    field.errorMsg = 'bitte ein gültiges Datum eingeben';
                    this.isValid = false;
                } else if (field.notInFuture && value > TimeStamp.getTodayString() ) {
                    field.errorMsg = 'Datum darf nicht in Zukunft liegen';
                    this.isValid = false;
                } else {
                    field.errorMsg = '';
                    this.isValid = true;
                }
                this.$emit('dateError', !this.isValid);
            },
            getErrorMsg(field){
                return field.errorMsg ? [field.errorMsg] : null
            }
        },
    }
</script>

<style scoped>

</style>